import { render, staticRenderFns } from "./OrganizationLogo.vue?vue&type=template&id=34d8909c&scoped=true"
import script from "./OrganizationLogo.vue?vue&type=script&lang=js"
export * from "./OrganizationLogo.vue?vue&type=script&lang=js"
import style0 from "./OrganizationLogo.vue?vue&type=style&index=0&id=34d8909c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d8909c",
  null
  
)

export default component.exports